import React, { Component } from 'react';
import {t} from "../../lang/i18n.js";
import {darkMode} from '../../Utils.js';
import TitleLoop from '../../components/TitleLoop/TitleLoop.js'

import './Page.scss'

export class Page extends Component {

  constructor(props) {
    super(props);

    let darkMode = typeof this.props.content.custom_fields.dark_mode_template !== 'undefined' && this.props.content.custom_fields.dark_mode_template;
    this.state = { data: {}, network: true, darkMode: darkMode };

  }

  componentDidMount() {
    darkMode(this.state.darkMode)
    this.setState({network: false});

    let scrollable = document.getElementsByClassName('site__scrollable')[0];
    scrollable.scrollTo(0,0);
  }

  render() {
    let title = this.props.content.title;
    let content = this.props.content.content;

    if (!this.state.network) {
      return (
        <main>
          <section className="module module--page module--ontop">
            <div className="module__inner">
              <header className="module__header">
                <div className="module__header__inner">
                  <h1 className="module__header__title ">
                    <TitleLoop title={title} />
                  </h1>
                </div>
              </header>

              <div className="module__body" data-scroll data-scroll-class="inview">
                <div className="module__body__inner">
                  <div className="module__body__content">
                    <div className="module__body__content__inner">
                      <div className="module__body__content__section module__body__content__section--fullwidth">
                        <div className="htmlcontent htmlcontent--2" dangerouslySetInnerHTML={{__html: content}} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      )
    } else {
      return (
        <main>

        </main>
      )
    }
  }
}
